import { autoCorrectedDatePipe } from './addons/AutoCorrectedDatePipe.js';

var MASK_PIPES = {
  AUTO_CORRECT_DATE: autoCorrectedDatePipe
};
var maskPipes = [MASK_PIPES.AUTO_CORRECT_DATE];

export { MASK_PIPES, maskPipes };
//# sourceMappingURL=MaskPipes.js.map
